import * as React from "react";
const SvgDesert = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M11.917 19.287c-.209.075-.414.152-.616.227l-.089.033c-1.328.495-2.597.953-4.462.953-1.694 0-2.309-.14-3.12-.326-.22-.05-.456-.104-.733-.16a.75.75 0 0 0-.294 1.471c.246.05.467.1.682.15.842.192 1.598.365 3.465.365 2.15 0 3.63-.542 4.986-1.047l.044-.017C13.105 20.443 14.293 20 16 20c2.378 0 3.781.47 4.972.946a.75.75 0 0 0 .557-1.392C20.219 19.03 18.622 18.5 16 18.5c-.35 0-.683.016-1 .046v-2.833l.962-.048A4.25 4.25 0 0 0 20 11.421V9a2 2 0 1 0-4 0v1.75a.75.75 0 0 1-.75.75H15V5a3 3 0 1 0-6 0v4.5h-.25A.75.75 0 0 1 8 8.75V7a2 2 0 1 0-4 0v2.42a4.25 4.25 0 0 0 4.038 4.245l.962.048v2.956a17.634 17.634 0 0 0-1.962-.29c-2.09-.193-3.867-.006-4.472.148a.75.75 0 1 0 .369 1.454c.394-.1 1.992-.29 3.965-.109 1.641.152 3.46.553 5.017 1.415ZM12 3.5A1.5 1.5 0 0 1 13.5 5v7.25c0 .414.336.75.75.75h1a2.25 2.25 0 0 0 2.25-2.25V9a.5.5 0 0 1 1 0v2.42a2.75 2.75 0 0 1-2.613 2.747l-1.675.084A.75.75 0 0 0 13.5 15v3.507c-.933-.648-1.961-1.114-3-1.446V13a.75.75 0 0 0-.713-.75l-1.674-.083A2.75 2.75 0 0 1 5.5 9.421V7a.5.5 0 0 1 1 0v1.75A2.25 2.25 0 0 0 8.75 11h1a.75.75 0 0 0 .75-.75V5A1.5 1.5 0 0 1 12 3.5Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgDesert;
